const DimensionsIconActive = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clip-path='url(#clip0_74714_2626)'>
        <path
          d='M16 8C16 8.368 15.7013 8.66667 15.3333 8.66667H12C11.632 8.66667 11.3333 8.368 11.3333 8C11.3333 7.632 11.632 7.33333 12 7.33333H15.3333C15.7013 7.33333 16 7.632 16 8ZM15.3333 13.3333H12C11.632 13.3333 11.3333 13.632 11.3333 14C11.3333 14.368 11.632 14.6667 12 14.6667H15.3333C15.7013 14.6667 16 14.368 16 14C16 13.632 15.7013 13.3333 15.3333 13.3333ZM6.66667 2.66667H15.3333C15.7013 2.66667 16 2.368 16 2C16 1.632 15.7013 1.33333 15.3333 1.33333H6.66667C6.29867 1.33333 6 1.632 6 2C6 2.368 6.29867 2.66667 6.66667 2.66667ZM9.33333 7.33333V8.66667C9.33333 9.402 8.73533 10 8 10H6.66667C5.93133 10 5.33333 9.402 5.33333 8.66667H2.66667V12C2.66667 12.7353 3.26467 13.3333 4 13.3333H5.33333C5.33333 12.598 5.93133 12 6.66667 12H8C8.73533 12 9.33333 12.598 9.33333 13.3333V14.6667C9.33333 15.402 8.73533 16 8 16H6.66667C5.93133 16 5.33333 15.402 5.33333 14.6667H4C2.52933 14.6667 1.33333 13.4707 1.33333 12V4C0.598 4 0 3.402 0 2.66667V1.33333C0 0.598 0.598 0 1.33333 0H2.66667C3.402 0 4 0.598 4 1.33333V2.66667C4 3.402 3.402 4 2.66667 4V7.33333H5.33333C5.33333 6.598 5.93133 6 6.66667 6H8C8.73533 6 9.33333 6.598 9.33333 7.33333Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_74714_2626'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DimensionsIconActive;
